enum BillingsCargoOrderListingViewMode {
  CARGO = "CARGO",
  RAILY = "RAILY",
}

export default BillingsCargoOrderListingViewMode;
